export const tokenAddresses = {
  EUL: "0xDef72Af3fc69E1Dd5a094f7DDa08Ba203CD0438B",
  eUSD: "0xf13DAcAdA8f45c2b2Cbf60eCb1D412d0C57bf2F8",
  rEUL: "0xff074349C8b89bB7362bD25c58742896D817A862",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
